<template>
  <ion-page>
    <ion-tabs>
      <ion-router-outlet></ion-router-outlet>
      <ion-tab-bar color="light" slot="bottom">
        <ion-tab-button tab="home" href="/tabs/home">
          <ion-icon :icon="home" />
          <ion-label>Home</ion-label>
        </ion-tab-button>
          
        <ion-tab-button tab="tab2" href="/tabs/walks" :disabled="!getGroup">
          <ion-icon :icon="walk" />
          <ion-label>Walks</ion-label>
        </ion-tab-button>
          
        <ion-tab-button tab="tab3" href="/tabs/events" :disabled="!getGroup">
          <ion-icon :icon="people" />
          <ion-label>Events</ion-label>
        </ion-tab-button>
          
        <ion-tab-button tab="tab4" href="/tabs/join">
          <ion-icon :icon="personAddOutline" />
          <ion-label>Join</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="settings" href="/tabs/settings">
          <ion-icon :icon="settingsSharp" />
          <ion-label>Settings</ion-label>
        </ion-tab-button>
      </ion-tab-bar>
    </ion-tabs>
  </ion-page>
</template>

<script>
import { defineComponent } from 'vue';
import { 
  IonTabBar, 
  IonTabButton, 
  IonTabs, 
  IonLabel, 
  IonIcon, 
  IonPage, 
  IonRouterOutlet 
} from '@ionic/vue';
import { home, walk, people, personAddOutline, settingsSharp } from 'ionicons/icons';
import localforage from "localforage";

export default defineComponent({
  name: 'TabsPage',
  components: {
    IonLabel, 
    IonTabs, 
    IonTabBar, 
    IonTabButton, 
    IonIcon, 
    IonPage, 
    IonRouterOutlet
  },
  setup() {
    const getGroup = async () => {
      const group = await localforage.getItem('group');
      return group;
    };

    return {
      home, 
      walk,
      people,
      personAddOutline,
      settingsSharp,
      getGroup,
    }
  }
});
</script>
